import { useDispatch } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';

import auth from './auth/auth';
import pki from './auth/pki';
import dept from './fidp/dept';
import organ from './fidp/organ';
import rangeOrgan from './fidp/rangeOrgan';
import position from './fidp/position';
import role from './fidp/role';
import user from './fidp/user';
import progress from './progress';
import preventScroll from './preventScroll';
import userRule from './user/userRule';
import setting from './setting';

export const rootReducer = combineReducers({
  auth,
  pki,
  dept,
  organ,
  rangeOrgan,
  position,
  role,
  user,
  progress,
  preventScroll,
  userRule,
  setting,
});

// export default createStore(rootReducer, applyMiddleware(thunk));
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cocatsList: any[] = [];
    if (import.meta.env.DEV) {
      // cocatsList.push(logger);
    }
    return getDefaultMiddleware().concat(cocatsList);
  }, // logger middleware추가
  devTools: import.meta.env.DEV, // dev모드에서만 devtool이 보이도록
});
export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAppDispatch = (): any => useDispatch<AppDispatch>();
